import BOOKING_DEFAULT from '../structs/booking';
import BOOKING_CUSTOMER_DEFAULT from '../structs/booking_customer';

export function bookQueryToBooking(bookQueries = []) {
  const bookingCustomer = Object.assign({}, BOOKING_CUSTOMER_DEFAULT, {});
  const booking = Object.assign({}, BOOKING_DEFAULT, {});
  const qf = {
    booking,
    bookingCustomer,
    customerID: null,
    hasBooking: false,
    hasBookingCustomer: false,
  };
  if (bookQueries.length > 0) {
    bookQueries.forEach((bq) => {
      if (!bq.name) return;
      switch (bq.name) {
        case 'book_external_id':
          qf.booking.externalID = bq.value || '';
          qf.hasBooking = true;
          break;
        case 'book_external_lead_id':
          qf.booking.externalLeadID = bq.value || '';
          qf.hasBooking = true;
          break;
        case 'book_external_customer_id':
          qf.booking.externalCustomerID = bq.value || '';
          break;
        case 'book_customer_id':
          qf.customerID = bq.value || '';
          break;
        case 'book_customer_identity':
          qf.bookingCustomer.identity = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_customer_identity_type':
          qf.bookingCustomer.identityTypeID = parseInt(bq.value, 10) || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_name':
          qf.bookingCustomer.name = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_mobile_prefix':
          qf.bookingCustomer.mobilePrefix = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_mobile':
          qf.bookingCustomer.mobile = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_email':
          qf.bookingCustomer.email = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        default:
          break;
      }
    });
  }
  return qf;
}



// WEBPACK FOOTER //
// ./src/utils/bookQuery.js